import serverApi from '../utils/serverApi';

const categoryService = {
  getCategories: () => serverApi({uri: 'categories', method: 'GET', isLoading: false}),
};

export default categoryService;
